import { cn } from '@/lib/cn';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export function Input({ label, error, hint, className, id, ...props }: InputProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="space-y-1.5">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-manejai-bark">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={cn(
          'w-full h-10 px-3 rounded-xl border bg-white text-sm transition-colors',
          'placeholder:text-manejai-bark/40',
          'focus:outline-none focus:ring-2 focus:ring-manejai-sage/40 focus:border-manejai-sage',
          error ? 'border-red-400' : 'border-manejai-sand',
          className,
        )}
        {...props}
      />
      {error && <p className="text-xs text-red-600">{error}</p>}
      {hint && !error && <p className="text-xs text-manejai-bark/60">{hint}</p>}
    </div>
  );
}
